// extracted by mini-css-extract-plugin
module.exports = {"root":"QBfk4mKq","styledLabel":"iLDIgAEO"};